import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Modal, Table } from "react-bootstrap";
//import { createDevice } from "../services/createDevice";
import Box from "@mui/material/Box";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import Select from "react-select";
import { environment } from "../../environment";
import CustomListDropDown from "../Components/CustomListDropDown";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import Multiselect from "multiselect-react-dropdown";
import { Redirect } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
  box_no,
} from "react-country-region-selector";
import { useEffect } from "react";
// import { Tabs, Tab } from "react-bootstrap-tabs";
import { Tabs, Tab } from "react-bootstrap";
import Container, { TableContainer, TextField } from "@mui/material";
import { SurveyQuestionPanelDynamicItem } from "survey-react-ui";

const MySwal = withReactContent(Swal);

const Mngreditreturnshipment = ({ history, match, props }) => {
  const [carton_no, setcartonno] = useState("");
  const [awb_no, setawbno] = useState("");
  const [box_no, setboxno] = useState("");
  const [date, setdate] = useState(new Date().toLocaleDateString());
  const [show, setShow] = useState(false);
  const [isAddProduct, setAddProduct] = useState(false);
  const [dap_consignees, setDapConsignees] = useState([]);
  const [consignee_details, setConsigneeDetails] = useState({});
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [boxId, setboxId] = useState("");
  const [boxtype, setboxtype] = useState("");
  const [name, setname] = useState("");
  const [deviceIdMongo, setdeviceIdMongo] = useState("");
  const [consigneeid, setconsigneeid] = useState("");
  const [currentTab, setCurrentTab] = useState(0);
  const [nameErrors, setNameErrors] = useState({});
  const [inventoryError, setInventoryError] = useState({});
  const [boxes, setboxes] = useState([]);
  const [zip, setzip] = useState("");
  const [reason, setReason] = useState("");
  const [tabledata, settabledata] = useState([]);
  const [checkInOther, setCheckInOther] = useState("");
  const [ourManager, setOurManager] = useState("");
  const [previousData, setPreviousData] = useState("");
  const [inputfields, setInputFields] = useState([
    {
      deviceIdMongo: "",
      deviceName: "",
      deviceLabel: "",
      deviceVersion: "",
      deviceType: "",
      deviceTypeId: "",
      accessToken: "",
    },
  ]);
  const [consignee_type, setConsigneeType] = useState("");
  const [showdevices, setShowDevices] = useState(false);
  const [devices, setDevices] = useState([]);
  const [devicesArray, setDevicesArr] = useState([]);
  const [disableAddBox, setDisableAddBox] = useState(true);
  const [tempDevice, setTempDevice] = useState([]);
  const [tempBoxes, setTempBoxes] = useState([]);

  // const [boxdetails, setboxDetails] = useState([
  //   {
  //     shipmentIdMongo: "",
  //     boxQr: "",
  //     shipmentDevices: inputfields,
  //   },
  // ]);
  // useEffect(() => {
  //   let id = match.params.id;
  //   console.log(id);
  //   getShipmentData(id);
  // }, []);

  const getShipmentData = (id) => {
    axios
      .get(environment.dap_url + "shipmentApi/getByIdWithLogs?_id=" + id)
      .then((res) => {
        console.log("ankit")
        console.log(res.data.shipmentDetails[0]);
        setConsigneeDetails(res.data.shipmentDetails[0].consigneedetails[0]);
        setAddress(res.data.shipmentDetails[0].address);
        setPhone(res.data.shipmentDetails[0].phone);
        setPostCountry(res.data.shipmentDetails[0].consignmentCountry);
        setPostCity(res.data.shipmentDetails[0].consignmentCity);
        setPostState(res.data.shipmentDetails[0].consignmentState);
        setconsigneeid(res.data.shipmentDetails[0].consigneedetails[0]._id);
        setConsigneeType(
          res.data.shipmentDetails[0].consigneedetails[0].userType
        );
        setEmail(res.data.shipmentDetails[0].email);
        setname(
          res.data.shipmentDetails[0].consigneedetails[0].userFirstName + " " + res.data.shipmentDetails[0].consigneedetails[0].userLastName
        );
        setcartonno(res.data.shipmentDetails[0].cartonQr);
        setzip(res.data.shipmentDetails[0].zip);
        setReason(res.data.shipmentDetails[0].Reason);

        const myData = res.data.shipmentDetails[0].shipmenboxes;
        console.log(myData);
        let yourArray = [];
        myData.forEach(yourbox => {
          console.log(yourbox);
          yourbox.shipmentDevices.forEach(yourdevice => {
            yourArray.push(yourdevice);
          });
        });
        setPreviousData(yourArray);

        // setboxes(res.data.shipmentDetails[0].shipmentBoxes)
        let arr = [];
        let boxDetails = {};
        let b_qr;
        let key = 0;
        let singleBoxArr = [];
        let singleBox = {};
        let boxArr = [];
        let shipmentIdMongo;
        let deviceArr = [];

        let boxAr = []
        let tableDataAr = []
        res.data.shipmentDetails[0].shipmenboxes.forEach(box => {
          let deviceAr = {};
          let boxQr = box.boxQr;
          let tableData = {
            boxLable: box.boxQr,
            boxType: box.boxType,
          }
          axios
            .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + boxQr)
            .then((res) => {
              console.log(res.data);
              tableData.boxType = res.data.boxType;
              let singleBox = {
                shipmentIdMongo: box.shipmentIdMongo,
                boxQr: box.boxQr,
                boxType: box.boxType,
                shipmentDevices: [],
              };

              box.shipmentDevices.forEach(device => {
                deviceAr = {
                  deviceIdMongo: device.deviceIdMongo,
                  deviceName: device.deviceName,
                  deviceLabel: device.deviceLabel,
                  deviceVersion: device.deviceVersion,
                  deviceType: device.deviceType,
                  deviceTypeId: device.deviceTypeId,
                  accessToken: device.accessToken,
                }
              })
              singleBox.shipmentDevices.push(deviceAr)
              boxAr.push(singleBox);
              tableDataAr.push(tableData)
            })
            .catch(function (error) {
              formValidationBox();
              console.log(error.message);
              // return {"id":"","type":""};
            });




        })
        console.log(boxAr, "boxAr");
        setboxes(boxAr)
        settabledata(tableDataAr)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submit = () => {

    if (email.length === 0) {
      MySwal.fire({
        title: "Partner details is empty, Please select partner",
        type: "error",
        icon: "error",
      });
      return;
    }
    if (carton_no.trim().length === 0) {
      MySwal.fire({
        title: "Cartoon no is empty. Please add cartoon no",
        type: "error",
        icon: "error",
      });
      return;
    }
    if (reason.trim().length === 0) {
      MySwal.fire({
        title: "Reason is empty. Please add reason",
        type: "error",
        icon: "error",
      });
      return;
    }
    if (
      boxes.length === 0
    ) {
      MySwal.fire({
        title: "Shipment is empty. Please add boxes",
        type: "error",
        icon: "error"
      });
      return;
    }

    boxes.forEach(boxItem => {
      boxItem.shipmentDevices.forEach(device => {
        const deviceId = device.deviceIdMongo;
        const inShipment = true;

        axios.put(environment.dap_url + "devices/updateShipment?deviceId=" + deviceId, { inShipment: inShipment })
          .then((resp) => {
            console.log(resp.data);
          }).catch((err) => {
            console.log(err);
          });
      });
    });

    const thisisarray = [];
    boxes.forEach(boxItem => {
      boxItem.shipmentDevices.forEach(device => {
        thisisarray.push(device);
      });
    })

    const result = previousData.filter(item => !thisisarray.some(elem => elem.deviceLabel === item.deviceLabel));

    result.forEach(item => {
      const deviceId = item.deviceIdMongo;
      const inShipment = false;

      axios.put(environment.dap_url + "devices/updateShipment?deviceId=" + deviceId, { inShipment: inShipment })
        .then((resp) => {
          console.log(resp.data);
        }).catch((err) => {
          console.log(err);
        });
    })

    let userdetails = JSON.parse(localStorage.getItem("userDetails"));
    let id = match.params.id;
    let req = {
      consignorId: ourManager._id,
      logisticId: ourManager._id,
      consigneeId: consigneeid,
      consignmentCity: postcity,
      consignmentState: poststate,
      consignmentCountry: postcountry,
      cartonQr: carton_no,
      name: name,
      zip: zip,
      reason: reason,
      email: email,
      address: address,
      phone: phone,
      notes: "",
      boxList: boxes,
    };
    console.log(req);
    axios
      .put(environment.dap_url + "shipmentApi/updateShipment?id=" + id, req)
      .then((res) => {
        MySwal.fire({
          title: <p>Shipment Updated</p>,
          type: "success",
        });
        history.push("/returnShipment");
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: <p>{err?.response?.data?.message}</p>,
          type: "error",
        });
      });
  };
  const formValidationBox = () => {
    const nameErrors = {};
    let isValid = true;
    nameErrors.noName = "Doesn't seem like a box ";
    isValid = false;
    setNameErrors(nameErrors);
    return isValid;
  };
  const formValidationInventory = () => {
    const inventoryError = {};
    let isValid = true;
    inventoryError.nodevice = "This Device is Not Presenet in Inventory";
    setCheckInOther(true);
    isValid = false;
    setInventoryError(inventoryError);
    return isValid;
  };
  const handleAddClick = (e) => {
    e.preventDefault();
    setInputFields([
      ...inputfields,
      {
        deviceIdMongo: "",
        deviceName: "",
        deviceLabel: "",
        deviceVersion: "",
        deviceType: "",
        deviceTypeId: "",
        accessToken: "",
      },
    ]);
    console.log("hero");
    console.log(inputfields);
  };
  const setConsigneeAddress = (e) => {
    setconsigneeid(e.value);
    axios
      .get(
        environment.dap_url +
        `shipmentApi/getPartnerDetailsById?consigneeId=` +
        e.value
      )
      .then((res) => {
        setAddress(res.data.address);
        setPhone(res.data.phone);
        console.log(res.data);
        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);
        setname(res.data.userFirstName + " " + res.data.userLastName);
        setEmail(res.data.email);
        setzip(res.data.zip);
        setConsigneeDetails(res.data);
      })
      .catch(function (error) {
        window.alert(error.message);
      });
  };

  useEffect(() => {
    const userKaData = JSON.parse(localStorage.getItem('managerdetails'));
    axios.get(environment.dap_url + "users/getUserById" + "?id=" + userKaData.data.createdBy)
      .then((res) => {
        setOurManager(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    const adminData = [{
      _id: '636d0685aa3a794e9ce58cd9',
      email: "sysadmin@thingsboard.org",
      userId: "6a077550-2bc8-11ec-a8be-370b5a76e8e2",
      userFirstName: "Sysadmin bbsr",
      profileImageUrl: "",
      userLastName: "HHG",
      userType: "SYS_ADMIN",
      organization: "HHG BHubaneswar",
      isActive: true,
      isDeleted: false,
      isConfirmedTerms: false,
      tenantId: "13814000-1dd2-11b2-8080-808080808080",
      customerId: "13814000-1dd2-11b2-8080-808080808080",
      pushNotificationId: "",
      __v: 0,
      awarness: 0,
      designation: "",
      industry: "",
      interest: 0,
      isLead: false,
      probablity: "0",
      source: "",
      zip: "987655",
      address: "",
      city: "Bhubaneshwar",
      country: "India",
      phone: "9090876890",
      state: "Odisha"
    }];
    setDapConsignees(adminData);
    let id = match.params.id;
    getShipmentData(id);
  }, []);

  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  const selectCountry = (e) => {
    console.log("country");
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };
  const handleRemoveClick = (index, e) => {
    e.preventDefault();
    const values = [...inputfields];
    values.splice(index, 1);
    setInputFields(values);
  };
  const handleChangeInput = (index, event) => {
    event.persist();
    const myarray = event.target.value.split("|");
    // console.log("myarray", myarray);
    if (myarray.length == 5) {
      scanqr(index, event, myarray);
      onScan(index, event);
    }
    const deviceLabel = event.target.value;
    const isDeviceLabelDuplicate = inputfields.some(
      (input, i) => i !== index && input.deviceLabel === deviceLabel
    );
    if (isDeviceLabelDuplicate) {
      setInventoryError({
        error: "Duplicate device label entered",
      });
      return;
    } else {
      setInventoryError({});
    }

    let myDeviceArray = [];
    tempBoxes.forEach(item => {
      item.forEach(item => {
        item.shipmentDevices.forEach(item => {
          myDeviceArray.push(item)
        })
      })
    })
    const exists = myDeviceArray.some(item => item.deviceLabel === deviceLabel);
    console.log(exists);

    const values = [...inputfields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
    if (exists) {
      if (event.target.name == "deviceLabel") {
        console.log("inside manual");
        axios
          .get(
            environment.dap_url +
            "dapDevice/isAssignedToCustomer?deviceLabel=" +
            event.target.value +
            "&utype=lg"
          )
          .then(async (deviceRes) => {
            console.log(deviceRes);
            setInventoryError({});
            setCheckInOther(false);
            if (deviceRes.status == 200) {
              if (deviceRes.data.available == true) {
                const parentId = JSON.parse(localStorage.getItem("user")).createdById;
                axios
                  .get(
                    environment.dap_url +
                    `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
                    event.target.value + `&partnerId=` + parentId
                  )
                  .then((res) => {
                    setInventoryError({});
                    setCheckInOther(false);
                    console.log(res.data);
                    values[index]["deviceIdMongo"] = res.data._id;
                    values[index]["deviceName"] = "OK";
                    values[index]["deviceTypeId"] = "1234";
                  })
                  .catch(function (error) {
                    formValidationInventory();
                    console.log(error.message);
                  });
              } else {
                setInventoryError({
                  error: "Device is already assigned to a customer",
                });
                setCheckInOther(true);
              }
            } else if (deviceRes.status == 201) {
              setInventoryError({
                error: "Device not found",
              });
              setCheckInOther(true);
            }
          })
          .catch((err) => {
            formValidationInventory();
          });
      }
    } else {
      if (event.target.name == "deviceLabel") {
        console.log("inside manual");
        axios
          .get(
            environment.dap_url +
            "dapDevice/isAssignedToCustomer?deviceLabel=" +
            event.target.value +
            "&utype=lg"
          )
          .then(async (deviceRes) => {
            console.log(deviceRes);
            setInventoryError({});
            setCheckInOther(false);
            if (deviceRes.status == 200) {
              if (deviceRes.data.available == true) {
                const parentId = JSON.parse(localStorage.getItem("user")).createdById;
                axios
                  .get(
                    environment.dap_url +
                    `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
                    event.target.value + `&partnerId=` + parentId
                  )
                  .then((res) => {
                    setInventoryError({});
                    setCheckInOther(false);
                    console.log(res.data);
                    if (res.data.inShipment) {
                      setInventoryError({ error: "Device is already in shipment" });
                      setCheckInOther(res.data.inShipment);
                    }
                    values[index]["deviceIdMongo"] = res.data._id;
                    values[index]["deviceName"] = "OK";
                    values[index]["deviceTypeId"] = "1234";
                  })
                  .catch(function (error) {
                    formValidationInventory();
                    console.log(error.message);
                  });
              } else {
                setInventoryError({
                  error: "Device is already assigned to a customer",
                });
                setCheckInOther(true);
              }
            } else if (deviceRes.status == 201) {
              setInventoryError({
                error: "Device not found",
              });
              setCheckInOther(true);
            }
          })
          .catch((err) => {
            formValidationInventory();
          });
      }
    }
  };
  const onScan = (index, event) => {
    console.log(index, event.target.name);
    let qrvalue = event.target.value;
    let qrCodeArray = qrvalue.split("|");
    const values = [...inputfields];
    // values[index][event.target.value] = qrCodeArray[0];
    console.log(values);
    setInputFields(values);
    // setInputFields([
    //   ...inputfields,
    //   {
    //     deviceType: qrCodeArray[1],
    //     deviceLabel:  qrCodeArray[0],
    //     accessToken:  qrCodeArray[2],
    //     deviceVersion:  qrCodeArray[3],
    //     isInstalled: false,
    //   },
    // ]);
    // values[index][event.target.name] = event.target.value;
  };
  const scanqr = (index, event, myarray) => {
    console.log("QRcodevalue", event.target.value);
    const values = [...inputfields];
    values[index]["deviceLabel"] = myarray[1];
    values[index]["deviceVersion"] = myarray[2];
    values[index]["accessToken"] = myarray[3];
    // values[index]["deviceType"] = myarray[0];
    var el = document.getElementById(index + "deviceType");
    el.value = myarray[0];
    if (myarray[1]) {
      axios
        .get(
          environment.dap_url +
          `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
          event.target.value
        )
        .then((res) => {
          setInventoryError({});
          console.log(res.data);
          values[index]["deviceIdMongo"] = res.data._id;
          values[index]["deviceName"] = res.data.deviceName;
          values[index]["deviceTypeId"] = "1234";
        })
        .catch(function (error) {
          formValidationInventory();
          console.log(error.message);
        });
    }
  };
  const handleAddPoduct = () => {
    setAddProduct(true);
  };

  const checkBox = (l) => {
    let myBoxArray = [];
    tempBoxes.forEach(item => item.forEach(item => myBoxArray.push(item.boxQr)));
    console.log(myBoxArray);

    if (!myBoxArray.includes(l)) {
      let boxArr = l.split('|')
      console.log(boxes);
      let label = '';
      if (boxArr.length > 1 && boxArr.length <= 5) {
        console.log("scan");
        label = boxArr[1]
        console.log(boxes.length);
        if (boxes.length > 0) {
          boxes.every(box => {
            console.log(box);
            console.log(box.boxQr == label);
            if (box.boxQr == label) {
              setNameErrors({ noName: "Box is already present in the shipment" })
              console.log("box is already present");
              setDisableAddBox(true);
              return false;
            } else {
              setNameErrors({})
              setDisableAddBox(false);
              axios
                .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
                .then((res) => {
                  console.log(res.data);
                  setboxId(res.data._id);
                  setboxtype(res.data.boxType);
                  return true
                })
                .catch(function (error) {
                  formValidationBox();
                  console.log(error.message);
                  setDisableAddBox(true)
                  return false
                });
            }
            // if(box.boxQr == label)
            //   return false
            return true;
          });
        } else {
          setNameErrors({})
          axios
            .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
            .then((res) => {
              console.log(res.data);
              setboxId(res.data._id);
              setboxtype(res.data.boxType);
              setDisableAddBox(false)
            })
            .catch(function (error) {
              formValidationBox();
              console.log(error.message);
              setDisableAddBox(true)
            });
        }


      } else {
        setNameErrors({})
        console.log("manual");
        label = l
        console.log(boxes.length);
        if (boxes.length > 0) {
          boxes.every(box => {
            console.log(box);
            console.log(box.boxQr == label);
            if (box.boxQr == label) {
              setNameErrors({ noName: "Box is already present in the shipment" })
              console.log("box is already present");
              setDisableAddBox(true);
              return false;
            } else {
              setNameErrors({})
              setDisableAddBox(false);
              axios
                .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
                .then((res) => {
                  console.log(res.data);
                  setboxId(res.data._id);
                  setboxtype(res.data.boxType);
                  return true
                })
                .catch(function (error) {
                  formValidationBox();
                  console.log(error.message);
                  setDisableAddBox(true)
                  return false
                });
            }
            // if(box.boxQr == label)
            //   return false
            return true;
          });
        } else {
          setNameErrors({})
          axios
            .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
            .then((res) => {
              if (res.status == 200) {
                setboxId(res.data._id);
                setboxtype(res.data.boxType);
                setNameErrors({});
                setDisableAddBox(false);
              } else if (res.status == 201) {
                setNameErrors({ noName: "Box is in used" })
                setDisableAddBox(true);
              } else {
                setNameErrors({ noName: "Not A Box.Please Scan A Box" })
                setDisableAddBox(true);
              }
            })
            .catch(function (error) {
              formValidationBox();
              console.log(error.message);
              setDisableAddBox(true)
            });
        }
      }

      setboxno(label)
    } else {
      console.log(myBoxArray);
      axios
        .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + l)
        .then((res) => {
          if (res.status == 200) {
            setboxId(res.data._id);
            setboxtype(res.data.boxType);
            setNameErrors({});
            setDisableAddBox(false);
          } else if (res.status == 201) {
            setNameErrors({ noName: "Box is in used" })
            setDisableAddBox(true);
          } else {
            setNameErrors({ noName: "Not A Box.Please Scan A Box" })
            setDisableAddBox(true);
          }
        })
        .catch(function (error) {
          formValidationBox();
          console.log(error.message);
          setDisableAddBox(true)
        });
    }
    setboxno(l)
  };
  const data = [];

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let boxlist = [];

  const removeShipmentBox = (index, event) => {
    event.preventDefault();
    const tableData = [...tabledata];
    setTempDevice([...tempDevice, tableData.splice(index, 1)]);
    settabledata(tableData);
    const boxesData = [...boxes];
    console.log(boxes);
    setTempBoxes([...tempBoxes, boxesData.splice(index, 1)]);
    setboxes(boxesData);

  };

  const PushData = () => {
    let flag = 0;
    let singleBox = {};
    let boxDetails = {};

    console.log(inputfields);

    const hasEmptyDevice = inputfields.some((data) => data.deviceLabel === '' || data.deviceType === '');
    console.log(hasEmptyDevice);
    console.log(hasEmptyDevice);

    const result = boxes.find(obj => {
      let found = false;
      inputfields.forEach(input => {
        if (obj.shipmentDevices.some(device => device.deviceLabel === input.deviceLabel)) {
          found = true;
        }
      });
      return found;
    });
    console.log(result);

    if (result) {
      let inventoryError = {};
      inventoryError.error = "Device is already in shipment";
      setInventoryError(inventoryError);
    } else {
      if (!hasEmptyDevice) {
        boxDetails.boxType = boxtype;
        boxDetails.boxLable = box_no;
        console.log(boxDetails);
        settabledata([...tabledata, boxDetails]);
        setboxes([...boxes, singleBox]);
        // setNames((current) => [...current, "Carl"]);
        singleBox.shipmentIdMongo = boxId;
        singleBox.boxQr = box_no;
        singleBox.boxType = boxtype;
        singleBox.shipmentDevices = inputfields;
        setboxes([...boxes, singleBox]);
        handleClose();
        setboxId("");
        setboxno("");
        setAddProduct(false);
        setInputFields([
          {
            deviceIdMongo: "",
            deviceName: "",
            deviceLabel: "",
            deviceVersion: "",
            deviceType: "",
            deviceTypeId: "",
            accessToken: "",
          },
        ]);
      } else {
        let inventoryError = {};
        console.log("Empty Fieldz");
        inventoryError.error = "Please fill all the fields";
        setInventoryError(inventoryError);
      };
    };
    // console.log(tabledata);
    // console.log(boxes)
  };

  const handleShowDevices = (key, event) => {
    console.log(boxes[key].shipmentDevices);
    setDevices(boxes[key].shipmentDevices);
    setShowDevices(true);
  };
  console.log(devices);

  const handleCloseDevices = () => {
    console.log(devicesArray);
    setShowDevices(false);
  };

  console.log(tempDevice);
  console.log(tempBoxes);
  console.log(consignee_details, "consignee_details");
  console.log(dap_consignees, "dap_consignees");

  console.log("This is Box", boxes);
  console.log("This is boxtype", boxtype);
  console.log("This is boxType", boxtype);
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Link to="/returnShipment" className="btn btn-light my-3">
              Go Back
            </Link>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <h3 className="text-center">EDIT Return Shipment</h3>
                <div className="card-body">
                  <Tabs activeKey={currentTab} onSelect={(tabKey) => setCurrentTab(tabKey)}>
                    <Tab eventKey={0} title="Basics Details">
                      <div className="row">
                        <div className="col-md-4">
                          <Form.Group controlId="consignee">
                            <Form.Label>Consignee </Form.Label>
                            <Select
                              options={dap_consignees.map((dap_consignee) => ({
                                id: dap_consignee._id,
                                value: dap_consignee._id,
                                label:
                                  dap_consignee.organization
                              }))}
                              value={{
                                id: consignee_details._id,
                                label:
                                  consignee_details.organization,
                                value: consignee_details.id,
                              }}
                              onChange={(e) => setConsigneeAddress(e)}
                              placeholder={"Consignee"}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Name"
                              value={name}
                              onChange={(e) => setname(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-4">
                          <Form.Group controlId="countri">
                            <Form.Label>Country</Form.Label>
                            <Select
                              options={countries.map((element) => ({
                                id: element.isoCode,
                                value: element.name,
                                label: element.name,
                              }))}
                              onChange={(e) => selectCountry(e)}
                              placeholder="Country"
                              value={{
                                id: "",
                                label: postcountry,
                                value: postcountry,
                              }}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-4">
                          <Form.Group controlId="name">
                            <Form.Label>State</Form.Label>
                            <Select
                              options={dap_states.map((element) => ({
                                id: element.isoCode,
                                value: element.name,
                                label: element.name,
                              }))}
                              onChange={(e) => selectRegion(e)}
                              // defaultValue={dap_deviceList[0].name}
                              value={{
                                id: "",
                                label: poststate,
                                value: poststate,
                              }}
                              placeholder="State"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-4">
                          <Form.Group controlId="name">
                            <Form.Label>City</Form.Label>
                            <Select
                              options={dap_city.map((element) => ({
                                id: element.isoCode,
                                value: element.name,
                                label: element.name,
                              }))}
                              onChange={(e) => selectCity(e)}
                              // defaultValue={dap_deviceList[0].name}
                              // defaultValue="hi there"
                              value={{ label: postcity, value: postcity }}
                              placeholder="City"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        {/* <div className="col-md-4">
                          <Form.Group controlId="">
                            <Form.Label>Zip</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div> */}
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Zip Code</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone"
                              value={zip}
                              onChange={(e) => setzip(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="carton">
                            <Form.Label>Carton No.</Form.Label>
                            <Form.Control
                              type="carton"
                              placeholder="Enter Carton No."
                              value={carton_no}
                              onChange={(e) => setcartonno(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="reason">
                            <Form.Label>Reason*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Reason for returning this device"
                              value={reason}
                              onChange={(e) => setReason(e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Button
                            className="success"
                            onClick={() => setCurrentTab(1)}
                            style={{ marginTop: 22, float: "left" }}
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey={1} title="Products">
                      <Button variant="primary" onClick={handleShow}>
                        Add Box
                      </Button>
                      {/* <div className="row">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-body">
                              <h4 className="card-title">DEVICES</h4>
                              <div className="row">
                                <div className="col-12">
                                  <ToolkitProvider
                                    keyField="id"
                                    bootstrap4
                                    data={boxes}
                                    columns={columns}
                                  ></ToolkitProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Box No.</th>
                            <th>Box Name.</th>
                            <th>Box Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tabledata?.map((val, key) => {
                            return (
                              <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{val.boxLable}</td>
                                <td>{val.boxType}</td>
                                <td>
                                  {/* <a
                                    data-mdb-toggle="tooltip"
                                    title="1 Product, 1 Charger"
                                  >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                  </a> */}
                                  <Button
                                    variant="primary"
                                    className="btn btn-sm"
                                    onClick={(e) => handleShowDevices(key, e)}
                                  >
                                    View
                                  </Button>
                                  <Button
                                    variant="danger"
                                    className="btn btn-sm"
                                    onClick={(e) => removeShipmentBox(key, e)}
                                  >
                                    Delete
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                          <Modal.Title>Box Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="col-md-12">
                            <div className="col-md-8">
                              <Form.Group controlId="box">
                                <Form.Label>Box No.</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Box No."
                                  value={box_no}
                                  onChange={(e) => checkBox(e.target.value)}
                                ></Form.Control>
                                <div>
                                  {Object.keys(nameErrors).map((key) => {
                                    return (
                                      <div style={{ color: "red" }}>
                                        {nameErrors[key]}
                                      </div>
                                    );
                                  })}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="col-md-6">
                              <Button
                                variant="primary"
                                onClick={handleAddPoduct}
                                disabled={disableAddBox}
                              >
                                Add Product
                              </Button>
                            </div>
                          </div>
                          {isAddProduct ? (
                            <div className="row">
                              <TableContainer>
                                {inputfields.map((inputField, index) => (
                                  <div key={index}>
                                    <TextField
                                      name="deviceType"
                                      label="Product Category"
                                      // variant="filled"
                                      id={index + "deviceType"}
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.deviceType}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <TextField
                                      name="deviceLabel"
                                      label="Label"
                                      // variant="filled"
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.deviceLabel}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <TextField
                                      name="deviceVersion"
                                      label="Version"
                                      // variant="filled"
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.deviceVersion}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <TextField
                                      name="accessToken"
                                      label="Access Token"
                                      // variant="filled"
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.accessToken}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <button
                                      className="btn btn-primary btn-sm"
                                      style={{
                                        margin: 10,
                                      }}
                                      onClick={(e) => handleAddClick(e)}
                                    >
                                      Add More
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      style={{
                                        margin: 10,
                                      }}
                                      onClick={(e) =>
                                        handleRemoveClick(index, e)
                                      }
                                    >
                                      Remove
                                    </button>

                                  </div>
                                ))}
                              </TableContainer>
                            </div>
                          ) : (
                            ""
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          <div>
                            {Object.keys(inventoryError).map(
                              (key) => {
                                return (
                                  <div style={{ color: "red" }}>
                                    {inventoryError[key]}
                                  </div>
                                );
                              }
                            )}
                          </div>
                          <Button variant="danger" onClick={handleClose}>
                            Close
                          </Button>
                          <Button variant="primary" onClick={PushData} disabled={checkInOther}>
                            Confirm
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Modal show={showdevices} onHide={handleCloseDevices}>
                        <Modal.Header closeButton>
                          <Modal.Title>Box Assets</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                {/* <th scope="col">Device Name</th> */}
                                <th scope="col">Device Label</th>
                                <th scope="col">Device Version</th>
                              </tr>
                            </thead>
                            <tbody>
                              {devices?.map((val, key) => {
                                return (
                                  <tr key={key}>
                                    <td>{key + 1}</td>
                                    {/* <td>{val.deviceName}</td> */}
                                    <td>{val.deviceLabel}</td>
                                    <td>{val.deviceVersion}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="danger" onClick={handleCloseDevices}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Button
                        className="success"
                        style={{ float: "right", margin: 10 }}
                        onClick={() => setCurrentTab(0)}
                      >
                        Prev
                      </Button>
                      <Button
                        className="success"
                        style={{ float: "right", margin: 10 }}
                        onClick={() => submit()}
                      >
                        Save
                      </Button>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mngreditreturnshipment;
